<div *ngIf="formGroup">
  <form [formGroup]="formGroup" formFocusable>
    <app-default-card
      [title]="'Konformitätserklärung'"
      [info]="'Bitte bestätigen, dass die angegeben Daten korrekt sind.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-accept-conditions
        [inputForm]="formGroup"
        [controlName]="'formConfirmation'"
        [disable]="false"
        [inputLink]=""
        [inputText]="
          'Hiermit erkläre(n) ich / wir, dass die angegebenen Daten korrekt sind.'
        "></app-accept-conditions>
    </app-default-card>
  </form>
</div>
